export const SET_INPUT_VALUE = 'SET_INPUT_VALUE';
export const SET_ROTATE_VALUE = 'SET_ROTATE_VALUE';
export const SET_INTERACTION_VALUE = 'SET_INTERACTION_VALUE';
